<template>
  <div
    v-if="activeView == 'authorizedUsers'"
    class="flex flex-col h-full py-10 px-16"
  >
    <div class="bg-white border border-gray-200 shadow-sm rounded-lg mb-8 p-8">
      <div class="flex justify-between items-baseline gap-5 mb-5">
        <p class="font-bold mb-5">Authorized Users ({{ users.length }})</p>
        <div class="flex gap-4">
          <input
            type="text"
            :placeholder="'Search for a user'"
            class="text-sm outline-none rounded-lg border border-gray-200"
            v-model="userSearch"
            maxlength="50"
          />
          <button
            @click="showUserInviteModal = true"
            class="bg-secondary text-sm text-white shadow-sm font-medium rounded-lg px-3 cursor-pointer"
          >
            Invite user
          </button>
        </div>
      </div>

      <div class="flex flex-col border border-gray-200 rounded-lg">
        <div class="flex items-center bg-gray-100 py-2">
          <div class="w-[30%] p-3">
            <p class="text-sm font-bold pl-3">Member details</p>
          </div>
          <div class="w-[10%] p-3">
            <p class="text-sm font-bold">Create</p>
          </div>
          <div class="w-[10%] p-3">
            <p class="text-sm font-bold">Edit</p>
          </div>
          <div class="w-[20%] p-3">
            <p class="text-sm font-bold">Distribute</p>
          </div>
          <div class="w-[15%] p-3">
            <p class="text-sm font-bold">Registration</p>
          </div>
          <div class="w-[15%] p-3">
            <p class="text-sm font-bold">Last connection</p>
          </div>
        </div>
        <div
          v-for="(user, index) in users
            .filter((user) =>
              user.email.toLowerCase().includes(userSearch.toLowerCase())
            )
            .sort((a, b) => {
              const aConnexion = connexions.find(
                (connexion) => connexion.email === a.email
              );
              const bConnexion = connexions.find(
                (connexion) => connexion.email === b.email
              );

              if (!aConnexion.registrationDate) return 1;
              if (!bConnexion.registrationDate) return -1;

              return (
                new Date(bConnexion.lastConnectionDate) -
                new Date(aConnexion.lastConnectionDate)
              );
            })"
          :key="user.email"
          class="flex items-center py-2 cursor-pointer"
          :class="{
            'bg-gray-100 bg-opacity-70': index % 2 != 0,
          }"
          @click="(activeUser = user), (activeView = 'user')"
        >
          <div
            class="w-[30%] p-3"
            :class="{
              'opacity-50': !connexions.find(
                (connexion) => connexion.email === user.email
              ).registrationDate,
            }"
          >
            <div class="flex items-center gap-3">
              <div
                class="flex-none w-8 h-8 rounded-full bg-[#2A72A9] flex items-center justify-center"
              >
                <p class="text-white font-medium">
                  {{ user.email.charAt(0).toUpperCase() }}
                </p>
              </div>
              <p class="font-medium">{{ user.email }}</p>
            </div>
          </div>
          <div class="w-[10%] p-3">
            <!-- <icon name="check" class="w-7 h-7 fill-blue-400" /> -->
          </div>
          <div class="w-[10%] p-3">
            <icon name="check" class="w-7 h-7 fill-blue-400" />
          </div>
          <div class="w-[20%] p-3">
            <icon name="check" class="w-7 h-7 fill-blue-400" />
          </div>
          <div class="w-[15%] p-3">
            <p
              class="text-gray-500"
              :class="{
                '!text-blue-500 font-medium': !connexions.find(
                  (connexion) => connexion.email === user.email
                ).registrationDate,
              }"
            >
              {{
                connexions.find((connexion) => connexion.email === user.email)
                  .registrationDate
                  ? new Date(
                      connexions.find(
                        (connexion) => connexion.email === user.email
                      ).registrationDate
                    ).toLocaleDateString()
                  : 'Pending'
              }}
            </p>
          </div>
          <div class="w-[15%] p-3">
            <p class="text-gray-500">
              {{
                connexions.find((connexion) => connexion.email === user.email)
                  .lastConnectionDate
                  ? new Date(
                      connexions.find(
                        (connexion) => connexion.email === user.email
                      ).lastConnectionDate
                    ).toLocaleDateString()
                  : ''
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-10">
      <div
        class="w-1/2 bg-white border border-gray-200 shadow-sm rounded-lg mb-32 p-8"
      >
        <p class="font-bold mb-5">Folders ({{ roles.length }})</p>
        <div class="flex flex-col gap-2 mb-4">
          <div
            v-for="role in roles"
            :key="role[0]"
            class="flex items-center border border-gray-200 rounded-lg gap-3 p-4 cursor-pointer"
            @click="(activeFolder = role), (activeView = 'folder')"
          >
            <div
              class="w-10 h-10 flex justify-center items-center bg-blue-600 rounded-lg"
            >
              <icon name="layers" class="w-5 h-5 fill-white" />
            </div>
            <div>
              <p class="font-bold">{{ role[4] }}</p>
              <p class="text-sm text-gray-500 leading-none">
                Assigned to {{ role[6].length }} users
              </p>
            </div>
          </div>
        </div>
        <div
          class="flex justify-center items-center bg-gray-100 rounded-lg gap-2 p-2 cursor-pointer"
        >
          <icon name="plus" class="w-5 h-5 fill-gray-700" />
          <p @click="createRole()" class="font-semibold text-gray-700">
            Add folder
          </p>
        </div>
      </div>
      <div
        class="w-1/2 bg-white border border-gray-200 shadow-sm rounded-lg mb-32 p-8"
      >
        <p class="font-bold mb-5">Folder</p>
        <p class="text-gray-500">This is an explanation for folder concept.</p>
      </div>
    </div>
  </div>
  <div v-if="activeView == 'user' && activeUser" class="flex flex-col h-full">
    <div
      class="flex justify-between items-center border-b border-gray-300 py-5 px-16"
    >
      <p class="font-bold text-lg">
        <icon name="account" class="mr-2" />User rights
      </p>
      <p
        class="text-sm px-2 cursor-pointer"
        @click="(activeView = 'authorizedUsers'), (activeUser = null)"
      >
        <icon name="cross" class="w-3 h-3 fill-gray-500" />
      </p>
    </div>
    <div class="py-8 px-16">
      <div class="flex items-center gap-3 mb-7">
        <div
          class="flex-none w-12 h-12 rounded-full bg-[#2A72A9] flex items-center justify-center"
        >
          <p class="text-white font-medium text-2xl">
            {{ activeUser.email.charAt(0).toUpperCase() }}
          </p>
        </div>
        <p class="font-bold text-lg">
          {{ activeUser.email }}
        </p>
      </div>
      <div class="flex gap-10">
        <div
          class="w-2/3 bg-white border border-gray-200 shadow-sm rounded-lg mb-32 p-8"
        >
          <p class="font-bold mb-1">Folders</p>
          <div class="flex items-center gap-5 mb-5">
            <p class="w-[55%] text-gray-500">
              Define the accesses and roles this user can have on folders
            </p>
            <input
              type="text"
              :placeholder="'Search folder'"
              class="w-[45%] h-10 outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="folderSearch"
              maxlength="50"
            />
          </div>
          <div class="flex items-center gap-7 mb-8">
            <p
              class="text-gray-500 font-medium cursor-pointer"
              :class="{ '!font-bold !text-black': folderFilter == 'all' }"
              @click="folderFilter = 'all'"
            >
              All ({{ roles.length }})
            </p>
            <p
              class="text-gray-500 font-medium cursor-pointer"
              :class="{ '!font-bold !text-black': folderFilter == 'affected' }"
              @click="folderFilter = 'affected'"
            >
              Roles ({{
                roles.filter((r) =>
                  activeUser.roles.find((userRole) => userRole[0] == r[0])
                ).length
              }})
            </p>
            <p
              class="text-gray-500 font-medium cursor-pointer"
              :class="{
                '!font-bold !text-black': folderFilter == 'unaffected',
              }"
              @click="folderFilter = 'unaffected'"
            >
              Unaffected ({{
                roles.filter(
                  (r) =>
                    !activeUser.roles.find((userRole) => userRole[0] == r[0])
                ).length
              }})
            </p>
          </div>

          <div class="flex flex-col gap-5">
            <div
              v-for="role in [...roles]
                .filter((r) => {
                  const matchesSearch =
                    !folderSearch ||
                    r[4].toLowerCase().includes(folderSearch.toLowerCase());
                  const matchesFilter =
                    folderFilter === 'all' ||
                    (folderFilter === 'affected' &&
                      activeUser.roles.find(
                        (userRole) => userRole[0] === r[0]
                      )) ||
                    (folderFilter === 'unaffected' &&
                      !activeUser.roles.find(
                        (userRole) => userRole[0] === r[0]
                      ));

                  return matchesSearch && matchesFilter;
                })
                .sort((a, b) =>
                  activeUser.roles.find((r) => r[0] == b[0]) ? 1 : -1
                )"
              :key="role"
              class="flex items-center justify-between"
            >
              <div class="flex items-center gap-2">
                <input
                  type="checkbox"
                  class="w-4 h-4 rounded-sm border border-gray-400 outline-none mt-0.5 cursor-not-allowed pointer-events-none"
                  :class="{
                    'opacity-50 ': activeUser.roles.find(
                      (r) => r[0] == role[0]
                    ),
                  }"
                  :checked="activeUser.roles.find((r) => r[0] == role[0])"
                />
                <div
                  class="w-8 h-8 flex justify-center items-center bg-blue-600 rounded-lg"
                >
                  <icon name="layers" class="w-4 h-4 fill-white" />
                </div>
                <div
                  @click="
                    activeFolder = role;
                    activeView = 'folder';
                  "
                  class="cursor-pointer"
                >
                  <p class="text-sm font-bold">{{ role[4] }}</p>
                  <p class="text-sm text-gray-500 leading-none">
                    {{ role[5].length }} badges
                  </p>
                </div>
              </div>
              <select
                class="w-[250px] border-none text-sm rounded-md py-2 px-3"
                :class="{
                  'bg-gray-200': activeUser.roles.find((r) => r[0] == role[0]),
                  'bg-gray-100': !activeUser.roles.find((r) => r[0] == role[0]),
                }"
                @change="
                  changeRoleForUser(
                    activeUser,
                    role,
                    $event.target.value === 'true'
                  )
                "
                :value="!!activeUser.roles.find((r) => r[0] == role[0])"
              >
                <option
                  class="text-sm text-gray-700 font-medium"
                  :value="false"
                >
                  Role | None
                </option>
                <option class="text-sm text-gray-700 font-medium" :value="true">
                  Role | Edit, Distribute
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="w-1/3">
          <p class="font-bold text-lg mb-5">Roles definitions</p>
          <div class="flex flex-col gap-5">
            <div
              class="bg-white border border-gray-200 shadow-sm rounded-lg p-5"
            >
              <p class="font-bold">Create</p>
              <p class="text-gray-500 mb-3">
                This is an explanation for create role.
              </p>
              <p class="text-blue-500 font-medium cursor-pointer">Details</p>
            </div>
            <div
              class="bg-white border border-gray-200 shadow-sm rounded-lg p-5"
            >
              <p class="font-bold">Editors</p>
              <p class="text-gray-500 mb-3">
                This is an explanation for edit role.
              </p>
              <p class="text-blue-500 font-medium cursor-pointer">Details</p>
            </div>
            <div
              class="bg-white border border-gray-200 shadow-sm rounded-lg p-5"
            >
              <p class="font-bold">Distribute</p>
              <p class="text-gray-500 mb-3">
                This is an explanation for distribute role.
              </p>
              <p class="text-blue-500 font-medium cursor-pointer">Details</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="activeView == 'folder' && activeFolder"
    class="flex flex-col h-full"
  >
    <div
      class="flex justify-between items-center border-b border-gray-300 py-5 px-16"
    >
      <p class="font-bold text-lg">
        <icon name="layers" class="mr-2" />Folder rights
      </p>
      <p
        class="text-sm px-2 cursor-pointer"
        @click="(activeView = 'authorizedUsers'), (activeUser = null)"
      >
        <icon name="cross" class="w-3 h-3 fill-gray-500" />
      </p>
    </div>
    <div class="py-8 px-16">
      <div class="flex items-center gap-3 mb-7">
        <div
          class="w-12 h-12 flex justify-center items-center bg-blue-600 rounded-xl"
        >
          <icon name="layers" class="w-6 h-6 fill-white" />
        </div>
        <div>
          <p class="font-bold text-lg leading-none mb-1">
            {{ activeFolder[4] }}
          </p>
          <p class="text-sm text-gray-500">
            {{ activeFolder[5].length }} badges
          </p>
        </div>
      </div>
      <div class="flex gap-10">
        <div
          class="w-2/3 bg-white border border-gray-200 shadow-sm rounded-lg mb-32 p-8"
        >
          <p class="font-bold mb-1">Users</p>
          <div class="flex items-center gap-5 mb-5">
            <p class="w-[55%] text-gray-500">
              Define the users accesses and roles for this folder
            </p>
            <input
              type="text"
              :placeholder="'Search user'"
              class="w-[45%] h-10 outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="userSearch"
              maxlength="50"
            />
          </div>
          <div class="flex items-center justify-between mb-8">
            <p class="font-bold text-black">All ({{ users.length }})</p>
            <p
              @click="
                showUserInviteModal = true;
                selectedFoldersForInvite = [activeFolder];
              "
              class="text-sm text-blue-500 font-medium cursor-pointer"
            >
              Invite user
            </p>
          </div>

          <div class="flex flex-col gap-5">
            <div
              v-for="user in [...users]
                .sort((a, b) =>
                  a.roles.find((r) => r[0] == activeFolder[0]) ? -1 : 1
                )
                .filter((user) =>
                  user.email.toLowerCase().includes(userSearch.toLowerCase())
                )"
              :key="user"
              class="flex items-center justify-between"
            >
              <div class="flex items-center gap-2">
                <input
                  type="checkbox"
                  class="w-4 h-4 rounded-sm border border-gray-400 outline-none mt-0.5 cursor-not-allowed pointer-events-none"
                  :class="{
                    'opacity-50 ': user.roles.find(
                      (r) => r[0] == activeFolder[0]
                    ),
                  }"
                  :checked="user.roles.find((r) => r[0] == activeFolder[0])"
                />
                <div
                  class="w-8 h-8 flex justify-center items-center bg-blue-600 rounded-lg"
                >
                  <icon name="layers" class="w-4 h-4 fill-white" />
                </div>
                <div
                  @click="
                    activeUser = user;
                    activeView = 'user';
                  "
                  class="cursor-pointer"
                >
                  <p class="text-sm font-medium">{{ user.email }}</p>
                </div>
              </div>

              <select
                class="w-[250px] border-none text-sm rounded-md py-2 px-3"
                :class="{
                  'bg-gray-200': user.roles.find(
                    (r) => r[0] == activeFolder[0]
                  ),
                  'bg-gray-100': !user.roles.find(
                    (r) => r[0] == activeFolder[0]
                  ),
                }"
                @change="
                  changeRoleForUser(
                    user,
                    activeFolder,
                    $event.target.value === 'true'
                  )
                "
                :value="!!user.roles.find((r) => r[0] == activeFolder[0])"
              >
                <option
                  class="text-sm text-gray-700 font-medium"
                  :value="false"
                >
                  Role | None
                </option>
                <option class="text-sm text-gray-700 font-medium" :value="true">
                  Role | Edit, Distribute
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="w-1/3">
          <div class="flex flex-col gap-5">
            <div
              class="bg-white border border-gray-200 shadow-sm rounded-lg p-5"
            >
              <div class="flex justify-between items-center">
                <p class="font-bold mb-5">
                  Badges ({{ activeFolder[5].length }})
                </p>
                <div class="flex gap-5">
                  <div class="relative">
                    <p
                      class="flex items-center text-blue-500 font-medium cursor-pointer"
                      @click="showTemplateDropdown = !showTemplateDropdown"
                      click-outside-ignore-template-dropdown
                    >
                      <icon name="plus" class="w-4 h-4 fill-blue-500 mr-1" />Add
                    </p>
                    <div
                      v-if="showTemplateDropdown"
                      class="absolute right-0 top-8 w-64 bg-white border border-gray-200 shadow-lg rounded-lg py-2 z-10"
                      click-outside-ignore-template-dropdown-target
                      v-click-outside="
                        () => {
                          showTemplateDropdown = false;
                        }
                      "
                    >
                      <div class="max-h-48 overflow-y-auto">
                        <div
                          v-for="template in fullTemplateList"
                          :key="template.id"
                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          @click="
                            addTemplateToRole(template.id, activeFolder[0]);
                            showTemplateDropdown = false;
                          "
                        >
                          <p class="text-sm text-gray-700">
                            {{ template.data?.name }}
                            <span class="text-xs text-gray-400">
                              ({{
                                template.data?.badgeCategory
                                  .charAt(0)
                                  .toUpperCase() +
                                template.data?.badgeCategory.slice(1)
                              }})
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p
                    class="flex items-center text-blue-500 font-medium cursor-pointer"
                    @click="
                      deleteTemplatesFromRole(
                        activeFolder[0],
                        toDeleteTemplateIds
                      );
                      toDeleteTemplateIds = [];
                    "
                  >
                    <icon
                      name="trash"
                      class="w-4 h-4 fill-blue-500 mr-1"
                    />Delete
                  </p>
                </div>
              </div>
              <div class="flex flex-wrap gap-3 mb-4 p-5">
                <div v-for="templateId in activeFolder[5]" :key="templateId">
                  <TemplatePreview
                    v-if="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      )?.data && currentIssuerInfo
                    "
                    @click="
                      if (toDeleteTemplateIds.includes(templateId)) {
                        toDeleteTemplateIds = toDeleteTemplateIds.filter(
                          (id) => id !== templateId
                        );
                      } else {
                        toDeleteTemplateIds.push(templateId);
                      }
                    "
                    :class="{
                      'border-4 border-blue-500 rounded-lg':
                        toDeleteTemplateIds.includes(templateId),
                    }"
                    :templateImage="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.image
                    "
                    :templateName="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.name
                    "
                    :templateLocation="
                      ['Participation', 'Ticket'].includes(
                        fullTemplateList.find(
                          (template) => template.id === templateId
                        ).data.badgeCategory
                      )
                        ? fullTemplateList
                            .find((template) => template.id === templateId)
                            .data.eventDetails.location.split(', ')[0]
                          ? fullTemplateList
                              .find((template) => template.id === templateId)
                              .data.eventDetails.location.split(', ')[0]
                          : $t('templateDisplay.virtualTxt')
                        : null
                    "
                    :templateStartDate="
                      ['Participation', 'Ticket'].includes(
                        fullTemplateList.find(
                          (template) => template.id === templateId
                        ).data.badgeCategory
                      )
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.eventDetails.startDate
                        : null
                    "
                    :templateEndDate="
                      ['Participation', 'Ticket'].includes(
                        fullTemplateList.find(
                          (template) => template.id === templateId
                        ).data.badgeCategory
                      )
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.eventDetails.endDate
                        : null
                    "
                    :templateThemeBgColor="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeTheme
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.badgeTheme.backgroundCardColor
                        : null
                    "
                    :templateThemeTextColor="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeTheme
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.badgeTheme.textColor
                        : null
                    "
                    :templateThemeEffect="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeTheme
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.badgeTheme.cardEffect
                        : null
                    "
                    :templateThemeTexture="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeTheme
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.badgeTheme.textureImageURL
                        : null
                    "
                    :templateThemeIsLogoBack="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeTheme
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.badgeTheme.isLogoBack
                        : null
                    "
                    :templateThemeShape="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeTheme
                        ? fullTemplateList.find(
                            (template) => template.id === templateId
                          ).data.badgeTheme.shape
                        : null
                    "
                    :issuerName="currentIssuerInfo.name"
                    :issuerImage="currentIssuerInfo.profileImage"
                    :type="
                      fullTemplateList.find(
                        (template) => template.id === templateId
                      ).data.badgeCategory
                    "
                    :formatSm="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showUserInviteModal">
    <div class="fixed top-0 left-0 w-full h-full z-10">
      <div class="absolute w-full h-full bg-black bg-opacity-20"></div>
    </div>
    <BasicSmModal @close="showUserInviteModal = false" absoluteClose>
      <p class="font-bold mb-7">Invite</p>
      <p v-if="!activeFolder" class="text-sm mb-3">
        Select at least one folder to invite users :
      </p>
      <div v-if="!activeFolder" class="grid grid-cols-2 gap-2 mb-4">
        <div
          v-for="role in roles"
          :key="role"
          class="flex items-center border border-gray-200 rounded-lg gap-2 p-2 cursor-pointer"
          :class="{
            '!border-blue-500 border-2': selectedFoldersForInvite.find(
              (folder) => folder[0] === role[0]
            ),
          }"
          @click="
            if (
              selectedFoldersForInvite.find((folder) => folder[0] === role[0])
            ) {
              selectedFoldersForInvite = selectedFoldersForInvite.filter(
                (folder) => folder[0] !== role[0]
              );
            } else {
              selectedFoldersForInvite.push(role);
            }
          "
        >
          <div
            class="w-5 h-5 flex justify-center items-center bg-blue-600 rounded-md"
          >
            <icon name="layers" class="w-3 h-3 fill-white" />
          </div>
          <div>
            <p class="text-sm font-medium">{{ role[4] }}</p>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <input
          type="text"
          :placeholder="'Add emails, separated by commas'"
          class="w-[75%] h-8 text-sm outline-none rounded-lg border border-gray-200"
          v-model="userEmailsToInvite"
          maxlength="50"
        />
        <button
          @click="inviteUsers()"
          class="w-[25%] h-8 bg-secondary text-sm text-white shadow-sm font-medium rounded-lg px-3 cursor-pointer"
          :class="{
            'opacity-50 cursor-not-allowed pointer-events-none':
              selectedFoldersForInvite.length === 0 ||
              userEmailsToInvite.length === 0,
          }"
        >
          Invite
        </button>
      </div>
    </BasicSmModal>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed, ref, inject, watch } from 'vue';
import TemplatePreview from '../../components/templates/TemplatePreview.vue';
import BasicSmModal from '../../components/BasicSmModal.vue';

export default {
  setup() {
    const store = useStore();
    const utils = inject('utils');
    const api = inject('api');

    const currentIssuerInfo = computed(
      () => store.getters.getCurrentIssuerInfo
    );
    const basicTemplateList = computed(
      () => store.getters.getBasicTemplateList
    );
    const communityTemplateList = computed(
      () => store.getters.getCommunityTemplateList
    );
    const participationTemplateList = computed(
      () => store.getters.getParticipationTemplateList
    );
    const ticketTemplateList = computed(
      () => store.getters.getTicketTemplateList
    );
    const roleTemplateList = computed(() => store.getters.getRoleTemplateList);

    const fullTemplateList = computed(() => {
      if (
        basicTemplateList.value &&
        communityTemplateList.value &&
        participationTemplateList.value &&
        ticketTemplateList.value &&
        roleTemplateList.value
      )
        return [
          ...basicTemplateList.value,
          ...communityTemplateList.value,
          ...participationTemplateList.value,
          ...ticketTemplateList.value,
          ...roleTemplateList.value,
        ];
      else return [];
    });

    const activeView = ref('authorizedUsers');
    const activeUser = ref(null);
    const activeFolder = ref(null);
    const selectedTemplate = ref(null);
    const selectedTemplates = ref([]);
    const roles = ref([]);
    const emails = ref([]);
    const folderFilter = ref('all');
    const folderSearch = ref('');
    const userSearch = ref('');
    const connexions = ref([]);
    const showTemplateDropdown = ref(false);
    const toDeleteTemplateIds = ref([]);
    const showUserInviteModal = ref(false);
    const selectedFoldersForInvite = ref([]);
    const userEmailsToInvite = ref([]);
    const users = ref([]);
    const nextActiveFolderId = ref(null);

    // add a watch on activeView
    watch(activeView, () => {
      if (activeView.value === 'authorizedUsers') {
        activeFolder.value = null;
        activeUser.value = null;
      }
      if (activeView.value === 'folder') {
        activeUser.value = null;
      }
      if (activeView.value === 'user') {
        activeFolder.value = null;
      }
    });

    watch(roles, (newRoles) => {
      if (newRoles.length == 0) {
        users.value = [];
        return;
      }

      let userEmails = [...new Set(newRoles.map((role) => role[6]).flat())];

      // if an email is not in the users array, add it to the users array
      const noRoleUserEmails = connexions.value
        .filter(
          (connexion) => !userEmails.find((email) => email === connexion.email)
        )
        .map((connexion) => connexion.email);
      userEmails = [...userEmails, ...noRoleUserEmails];

      users.value = userEmails.map((email) => {
        return {
          email,
          roles: newRoles.filter((role) => role[6].includes(email)),
        };
      });

      // refresh active data
      if (activeUser.value) {
        activeUser.value = users.value.find(
          (user) => user.email === activeUser.value.email
        );
        if (!activeUser.value && activeView.value === 'user') {
          activeView.value = 'authorizedUsers';
        }
      }
      if (nextActiveFolderId.value) {
        activeFolder.value = roles.value.find(
          (role) => role[0] === nextActiveFolderId.value
        );
        nextActiveFolderId.value = null;
        activeView.value = 'folder';
      }
    });

    async function createGroup() {
      api
        .createResourceGroup({
          resourceType: 'template',
          resourceIdList: selectedTemplates.value.map(
            (template) => template.id
          ),
        })
        .then((res) => {
          getManagerRoles();
          selectedTemplates.value = [];
          selectedTemplate.value = null;
        });
    }

    async function createRole() {
      const existingRoleNumbers = roles.value
        .map((role) => {
          const match = role[4].match(/Role (\d+)/);
          return match ? parseInt(match[1]) : 0;
        })
        .filter((num) => num > 0);
      const nextNumber =
        existingRoleNumbers.length > 0
          ? Math.max(...existingRoleNumbers) + 1
          : 1;
      api.createRole({ name: `Role ${nextNumber}` }).then((res) => {
        nextActiveFolderId.value = res.data.roleId;
        getManagerRoles();
      });
    }

    async function getManagerRoles() {
      api.getManagerRoles().then((res) => {
        emails.value = Array(roles.value.length).fill('');
        roles.value = res.data.roles;
        connexions.value = res.data.connexions;

        // refresh active folder
        if (activeFolder.value) {
          activeFolder.value = roles.value.find(
            (role) => role[0] === activeFolder.value[0]
          );
        }

        // setTimeout(() => {
        //   activeUser.value = users.value[0];
        //   activeFolder.value = roles.value[0];
        //   activeView.value = 'user';
        // }, 100);
      });
    }
    getManagerRoles();

    async function addUserToRole(email, roleId) {
      api.addUserToRole({ email, roleId }).then((res) => {
        getManagerRoles();
      });
    }

    async function addTemplateToRole(templateId, roleId) {
      api.addTemplateToRole({ templateId, roleId }).then((res) => {
        getManagerRoles();
      });
    }

    async function deleteTemplatesFromRole(roleId, templateIds) {
      if (templateIds.length === 0) {
        utils.showToastMessageError('Select at least one template');
        return;
      }
      api.deleteTemplatesFromRole({ roleId, templateIds }).then((res) => {
        getManagerRoles();
      });
    }

    async function changeRoleForUser(user, role, giveRole) {
      if (giveRole) {
        api
          .addUserToRole({ email: user.email, roleId: role[0] })
          .then((res) => {
            getManagerRoles();
          });
      } else {
        api
          .removeUserFromRole({ email: user.email, roleId: role[0] })
          .then((res) => {
            getManagerRoles();
          });
      }
    }

    async function inviteUsers() {
      const emails = userEmailsToInvite.value
        .split(',')
        .map((email) => email.trim());

      // check emails are valid
      const validEmails = emails.filter((email) =>
        email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
      );
      if (validEmails.length !== emails.length) {
        utils.showToastMessageError('Invalid emails');
        return;
      }
      const roleIds = selectedFoldersForInvite.value.map((folder) => folder[0]);

      api
        .inviteUsersToRoles({
          emails,
          roleIds,
        })
        .then((res) => {
          getManagerRoles();
          showUserInviteModal.value = false;
          userEmailsToInvite.value = [];
          selectedFoldersForInvite.value = [];
        });
    }

    return {
      fullTemplateList,
      selectedTemplate,
      selectedTemplates,
      createGroup,
      roles,
      addUserToRole,
      emails,
      currentIssuerInfo,
      users,
      activeView,
      activeUser,
      activeFolder,
      folderFilter,
      folderSearch,
      userSearch,
      connexions,
      addTemplateToRole,
      showTemplateDropdown,
      toDeleteTemplateIds,
      deleteTemplatesFromRole,
      changeRoleForUser,
      showUserInviteModal,
      selectedFoldersForInvite,
      userEmailsToInvite,
      inviteUsers,
      createRole,
    };
  },
  components: {
    TemplatePreview,
    BasicSmModal,
  },
};
</script>
